import { VCryptoAlgorithm, VCryptoHashFunction, VPublicKeyRequest, VPublicKeyResponse, VResponseCode } from '@datarock/protobuffers';
import { EncodedEndpoint } from './Encoded';
class ServerPublicKeyEndpoint extends EncodedEndpoint {
    async getRequestInit({ deviceId }) {
        const requestBytes = VPublicKeyRequest.encode({
            availableAlgorithms: [VCryptoAlgorithm.RSA_OAEP],
            availableHashFunctions: [VCryptoHashFunction.SHA_256],
            deviceId
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    process(value, ...args) {
        var _a, _b;
        const decoded = super.process(value, args);
        const response = VPublicKeyResponse.decode(decoded);
        if (((_a = response.response) === null || _a === void 0 ? void 0 : _a.code) !== VResponseCode.SUCCESS) {
            throw new Error((_b = response.response) === null || _b === void 0 ? void 0 : _b.text);
        }
        return response;
    }
}
export const getServerPublicKeyEndpoint = new ServerPublicKeyEndpoint({
    path: '/sessionsecurity',
    method: 'POST',
    sideEffect: true,
    body: {},
    schema: VPublicKeyResponse
});
